<template>
  <div class="home">
    <b-container fluid>
      <b-row>
        <b-col>
          <h1>Credentialer Reports:</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <BaseSelector label="Filter user:" :options="this.credentialers" v-model="selectedCredentialer" :v="$v.selectedCredentialer"/>
          <b-button variant="primary" class="m-2" @click="search()">Search</b-button>
          <b-button variant="secondary" class="m-2" @click="clear()">Clear</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <BaseTextOutput label="Unassigned applications:" :value="assignmentData.unassigned"/>
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col cols="12">
          <BaseTextOutput :label="'Assigned applications ('+(
              searchCredentialer==null?'overall':('for '+searchCredentialer.text))+'):'"
                          :value="assignmentData.assigned"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <BaseTextOutput label="Received" :value="assignmentData.received"/>
        </b-col>
        <b-col cols="4">
          <BaseTextOutput label="Returned" :value="assignmentData.returned"/>
        </b-col>
        <b-col cols="4">
          <BaseTextOutput label="Resubmitted" :value="assignmentData.resubmitted"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <BaseTextOutput label="Approved" :value="assignmentData.approved"/>
        </b-col>
        <b-col cols="4">
          <BaseTextOutput label="Processed" :value="assignmentData.processed"/>
        </b-col>
        <b-col cols="4">
          <BaseTextOutput label="Denied" :value="assignmentData.denied"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
import BaseParagraphInput from "@/components/templates/input/BaseParagraphInput";
import axios from 'axios';
import {required, requiredIf, minLength, maxLength, email} from 'vuelidate/lib/validators'
import FileAttachmentSupplemental from "@/components/templates/input/FileAttachmentSupplemental";
import BaseSelector from "@/components/templates/input/BaseSelector";
import moment from 'moment';

import {commonOptions} from "@/mixins/commonOptions";
import AdminAttachmentList from "@/components/templates/AdminAttachmentList";
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import BaseMaskedTextInput from "@/components/templates/input/BaseMaskedTextInput.vue";
import BaseDateOfBirthInput from "@/components/templates/input/BaseDateOfBirthInput.vue";
import BaseCheckboxInput from "@/components/templates/input/BaseCheckboxInput.vue";
import BaseRadioInput from "@/components/templates/input/BaseRadioInput.vue";
import {assign} from "lodash";

export default {
  name: "CredentialerReports",
  components:{
    BaseTextOutput,
    BaseSelector,

  },
  mixins: [
    commonOptions
  ],
  data:()=>({
    credentialers: [],
    selectedCredentialer: null,
    searchCredentialer: null,
    assignmentData: [],
  }),
  created(){
    this.loadCredentiallers();
    this.loadStats();
  },
  methods: {
    assign,
    loadCredentiallers(){
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/credentialers`)
          .then(response => {
            this.credentialers = response.data
          })
    },
    loadStats(){
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/assignmentData`)
          .then(response => {
            this.assignmentData = response.data;
          })
    },
    search(){
      this.searchCredentialer = this.credentialers.find(c=>c.value===this.selectedCredentialer);
      console.log(this.searchCredentialer)
      this.assignmentData = [];
      this.$nextTick(()=>{
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/assignmentData/${this.searchCredentialer.value}`)
            .then(response=>{
              this.assignmentData = response.data;
            })
      })
    },
    clear(){
      this.searchCredentialer = null;
      this.assignmentData = [];
      this.loadStats();
    }
  },
  validations: {
    selectedCredentialer: {required: false}
  },
  computed: {
  }

}
</script>

<style scoped>
p {
  font-weight: 700;
}

</style>